function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    
    // Extend - Dispatch refreshCart to soft refresh cart in extend-cart-integration upon changing quantity
    window.dispatchEvent(new Event('refreshCart'))
    // Extend - End code
    
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
    const regex = /(?:^(properties\[))(.*?)(?:\])/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
    
    function upsellItems() {
    var cartItemFirst = document.querySelectorAll('.cart-drawer .cart-drawer__item')[0];
    var cartItemFirstTitle = document.querySelectorAll('.cart-drawer .cart-drawer__item .drawer-item-title')[0];
    var upsellItemsBlock = document.getElementById('upsell-items');
    var cartDrawerInner = document.querySelector('.cart-drawer__inner');
    var upsellItemsArr = document.querySelectorAll('#upsell-items .upsell-item');
    
    if (cartItemFirst != null && cartItemFirstTitle != null) {

      var lineProductHandle = cartItemFirstTitle.getAttribute('data-line-handle');
      var lineAcviteTag = cartItemFirst.getAttribute('data-active-tag');

      if (lineAcviteTag == 'active' || cartItemFirstTitle.innerHTML.indexOf('Extend Shipping Protection Plan') > -1) {
        if (upsellItemsBlock != null) {
        	upsellItemsBlock.style.display = '';
      	}
    
    	if (window.innerWidth > 989) {
  			cartDrawerInner.style.width = '450px';
  		}
      } else {
  		if (upsellItemsBlock != null) {
        	upsellItemsBlock.style.display = 'none';
      	}
    
    	if (window.innerWidth > 989) {
  			cartDrawerInner.style.width = '450px';
  		}
  	  }
    
      if (upsellItemsArr.length > 0) {
    
      	var count = 0;
    
    	upsellItemsArr.forEach(function(item){
  			var mainHandle = item.querySelector('.upsell-title').getAttribute('data-upsell-handle');
    
    		if (lineProductHandle == mainHandle) {
  				item.style.display ='';
                count++;
  			} else {
  				item.style.display ='none';
  			}
  		});
    
        if(count == 0) {
         document.querySelector('[data-uspell-product-handle="maggie"]').style.display ='block';
       }
    
      }
  	} else {
      if (window.innerWidth > 989 && cartDrawerInner != null) {
      	cartDrawerInner.style.width = '450px';
      }
  	}
  }

  function openCartDrawer() {
	var cartDrawer = document.querySelector('.cart-drawer');
    var cartDrawerInner = document.querySelector('.cart-drawer__inner');
    
    if (cartDrawer != null) {
  		cartDrawer.style.zIndex = '1000';
    	cartDrawer.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
	    cartDrawer.classList.add('active_drawer');
      // Judge.me's cart drawer widget treats the drawer as open on class
      // "active"/"animate" or an "open" attribute — mirror our state onto "open".
      cartDrawer.setAttribute('open', '');
    }
    
    if (cartDrawerInner != null) {
  		cartDrawerInner.style.zIndex = '1200';
    	cartDrawerInner.style.transform = 'translateX(0)';
  	}
    
    document.querySelector('body').classList.add('scroll-lock');
    upsellItems()
  }

  function closeCartDrawer() {
	var cartDrawer = document.querySelector('.cart-drawer');
    var cartDrawerInner = document.querySelector('.cart-drawer__inner');
    
    if (cartDrawer != null) {
  		cartDrawer.style.zIndex = '';
    	cartDrawer.style.backgroundColor = '';
     	cartDrawer.classList.remove('active_drawer');
      cartDrawer.removeAttribute('open');
    }
    
    if (cartDrawerInner != null) {
  		cartDrawerInner.style.zIndex = '';
    	cartDrawerInner.style.transform = '';
  	}
    
    document.querySelector('body').classList.remove('scroll-lock');
  }
    
  var cartIcons = document.querySelectorAll('.header__icon--cart');
  var carDrawerCloseIcon = document.querySelector('.cart-drawer-close');
  var cartDrawerWrapper = document.querySelector('.cart-drawer');
    
  if (cartIcons.length > 0) {
    cartIcons.forEach(function(item){
    	item.addEventListener("click", function(e) {
          e.preventDefault();
    	  openCartDrawer();
        });
    });
  }
    document.addEventListener('click', function(e){
    let el = e.target;

    if(el.classList.contains('cart-drawer-close') || el.closest('.cart-drawer-close')) {
    closeCartDrawer();
    return false;
  }
  });

//   if (carDrawerCloseIcon != null) {
//     carDrawerCloseIcon.addEventListener("click", function(e) {
    //       e.preventDefault();
    //       closeCartDrawer();
    //     });
    //   }

  document.addEventListener('click', function(e){
    let el = e.target;
    var active_drawer = document.querySelector('.active_drawer');
    if(active_drawer) {
    
      if(el.classList.contains('cart-drawer')) {
        closeCartDrawer();
      }
    }
  });

  // Judge.me injects its cart drawer carousel into .cart-drawer__items, which sits
  // inside the drawer's <form action="/cart" method="post">. Its arrows are plain
  // <button> elements with no type attribute, so the browser treats them as submit
  // buttons: clicking one posts the form and lands the customer on the cart page
  // instead of moving the slider. Neutralise them in the capture phase, before the
  // widget's own onclick runs, so the very first click already behaves.
  document.addEventListener('click', function(e) {
    var widgetButton = e.target.closest('#jdgm-cart-drawer-widget button:not([type])');
    if (!widgetButton) return;

    widgetButton.setAttribute('type', 'button');
    e.preventDefault();
  }, true);

function updateCartCount() {
   fetch('/cart/update.js')
  .then(response => {
    if (response.ok) {
      return Promise.resolve(response);
    }
    else {
      return Promise.reject(new Error('Failed to load')); 
    }
  })
  .then(response => response.json()) 
  .then(data => {
     let updateCartCount = data.item_count;
     document.querySelector('.cart-count-bubble span').innerHTML = updateCartCount;
  })
  .catch(function(error) {
    console.log('Error: ' + error.message);
  });

  // Extend - Dispatch refreshAjaxCart to soft refresh cart in extend-ajax-cart-integration
  window.dispatchEvent(new Event('refreshAjaxCart'))

  window.loyaltylion && window.loyaltylion.ui.refresh();
  // Extend - End code
    
}
function refreshCart() {
 
  fetch('/cart?view=ajax')
  .then(response => {
    if (response.ok) {
      return Promise.resolve(response);
    }
    else {
      return Promise.reject(new Error('Failed to load')); 
    }
  })
  .then(response => response.text()) 
  .then(data => {
   
    let cart_drawerEl = document.querySelector('.cart-drawer');
    if(cart_drawerEl) {
	let isActive_drawer = cart_drawerEl.classList.contains('active_drawer');
    
    cart_drawerEl.innerHTML = data;
    var el = cart_drawerEl.querySelector('.cart-drawer');

    // get the element's parent node
    var parent = el.parentNode;

    // move all children out of the element
    while (el.firstChild) parent.insertBefore(el.firstChild, el);

    // remove the empty element
    parent.removeChild(el);

    if(isActive_drawer) {
    openCartDrawer();
  } else {
    setTimeout(function() {
    openCartDrawer();
  },100);
  }
    }
    updateCartCount();
  })
  .catch(function(error) {
    console.log('Error: ' + error.message);
  });
}

async function changeQty(data) {

  let response = await fetch('/cart/change.js', {
    method: 'POST',
    cache: 'no-cache',
    mode: 'cors', 
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data)
  });
  let result = await response.json();
  refreshCart();
}
document.addEventListener('click', function(e){
  let el = e.target;
  if(el.classList.contains('item_remove_link') || el.closest('.item_remove_link')) {
    if(!el.classList.contains('item_remove_link')) {
      el = el.closest('.item_remove_link');
    }
    e.preventDefault();
 
    let item_id = el.getAttribute('data-item-id');
    let data = {
      "id": item_id,
      "quantity": 0
    }
    changeQty(data);
  }
});
document.addEventListener('change', function(e){
  let el = e.target;
  if(el.classList.contains('cart-quantity-select')) {
    e.preventDefault();
    let val = +(el.value);      
    let item_id = el.getAttribute('data-item-id');
    let item_line = el.getAttribute(' data-item-line');

    let data = {
      "id": item_id,
      "quantity": val
    }
    changeQty(data);
  }
});

// BEGIN: QTY Selector

document.addEventListener('input', function(e){
  let el = e.target;
  if(el.classList.contains('product-form-input')) {
    
    let val = +(el.value);      
    let item_id = el.getAttribute('data-item-id');
    let item_line = el.getAttribute('data-item-line');

    let data = {
      "id": item_id,
      "quantity": val
    }
    changeQty(data);
  }
});

document.addEventListener('click', function(e) {
  let el = e.target;

  if (el.classList.contains('qty-button')) {
    let parent = el.closest('.qty-input');

    if (parent) {
      let input = parent.querySelector('input[type="number"]');
      
      if (input) {
        let item_id = input.getAttribute('data-item-id');
        
        if (el.classList.contains('qty-add')) {
          input.value = +input.value + 1;
        } else if (el.classList.contains('qty-sub')) {
          if (+input.value > 1) {
            input.value = +input.value - 1;
          }
        }

        let val = +input.value;

        let data = {
          "id": item_id,
          "quantity": val
        }

        changeQty(data);
      }
    }
  }
});

// END: QTY Selector

document.addEventListener('click', function(e){
  let el = e.target;
  if(el.classList.contains('add-upsell-btn') || el.closest('.add-upsell-btn')) {
    if(!el.classList.contains('add-upsell-btn')) {
      el = el.closest('.add-upsell-btn');
    }
    e.preventDefault();
    el.setAttribute('disabled','disabled');

  var varId = el.getAttribute('data-variant-id') * 1;

    let formData = {
      'items': [{
        'id': varId,
        'quantity': 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(function (response) {
      if (response.ok) {
        el.removeAttribute('disabled');
       refreshCart();

      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          el.removeAttribute('disabled');
          el.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  }
});

$(document).ready(function() {
  $('.accordion-section__item .title').on('click', function(e){
    e.preventDefault();

    if($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $('.accordion-section__item.active').removeClass('active');
      $(this).addClass('active');
    }

    $(this).next('.content').slideToggle();
    $(this).closest('.accordion-section__item').siblings().find('.content').slideUp();
  });
});

if($(".template-product .product__info-wrapper .product-form").length) {
  $(window).scroll(function() {
      var top_of_element = $(".template-product .product__info-wrapper .product-form").offset().top;
      var bottom_of_element = top_of_element + $(".template-product .product__info-wrapper .product-form").outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();
  
      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        $(".template-product .sticky-add-to-cart").removeClass('fixed');
      } else {
        $(".template-product .sticky-add-to-cart").addClass('fixed');
      }
  }); 
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  if (!anchor.classList.contains('recover_link') && !anchor.classList.contains('cancel_link')) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  }
});


// Product Page - Sticky Button
//
// The bar is a copy of the main add to cart button, so it has to show the same
// label — and that label is not fixed. variants.js rewrites it on variant change,
// and Klaviyo's back in stock script replaces the button with a "Join Waitlist"
// trigger whenever the variant cannot be bought; in a market the product is not
// sold in, that is every variant. The bar kept offering "Add to Cart" there, which
// posted a variant the cart refused and left the cart empty.
//
// Nothing here touches the main button: it is only read. When it is a waitlist
// trigger the bar scrolls up to it and lets the customer press it themselves.

// Klaviyo renders its trigger with the classes from the `product_page_class`
// option, so it cannot be found by class alone. Try its own hooks, then fall back
// to matching the label.
var KLAVIYO_BIS_SELECTORS = [
  '.product-form__buttons .klaviyo-bis-trigger',
  '.product-form__buttons [class*="klaviyo-bis"]',
  '.product-form__buttons [id*="klaviyo-bis"]'
].join(', ');

var WAITLIST_LABEL_PATTERN = /waitlist|notify me|back in stock/i;

function readButtonLabel(node) {
  var text = node.tagName === 'INPUT' ? node.value : node.textContent;
  return (text || '').replace(/\s+/g, ' ').trim();
}

function writeButtonLabel(node, label) {
  if (node.tagName === 'INPUT') {
    node.value = label;
  } else {
    node.textContent = label;
  }
}

function isVisibleNode(node) {
  return node.offsetParent !== null;
}

// The element the customer actually presses at the top of the page: the theme's
// own button, or whatever replaced it.
function getMainAddToCartButton() {
  var themeButton = document.querySelector('.product-form__atc [name="add"]');
  var themeButtonUsable = themeButton
    && isVisibleNode(themeButton)
    && !themeButton.disabled
    && !themeButton.hasAttribute('disabled');

  if (themeButtonUsable) return themeButton;

  var klaviyoTrigger = document.querySelector(KLAVIYO_BIS_SELECTORS);
  if (klaviyoTrigger && isVisibleNode(klaviyoTrigger)) return klaviyoTrigger;

  // Klaviyo's classes are ours, so its trigger is not identifiable by selector.
  // With the theme button out of action, a visible waitlist label in the product
  // info is that trigger.
  var infoContainer = document.querySelector('.product__info-container');
  if (infoContainer) {
    var byLabel = Array.prototype.slice.call(
      infoContainer.querySelectorAll('button, a, [role="button"], input[type="button"], input[type="submit"]')
    ).find(function (node) {
      // `.join-waitlist-link` is the mailto fallback copy, not a trigger.
      if (node.closest('.join-waitlist-link')) return false;
      return isVisibleNode(node) && WAITLIST_LABEL_PATTERN.test(readButtonLabel(node));
    });
    if (byLabel) return byLabel;
  }

  return themeButton;
}

function syncStickyAddToCart() {
  var stickyButton = document.querySelector('.sticky-add-to-cart_form .button');
  var mainButton = getMainAddToCartButton();
  if (!stickyButton || !mainButton) return;

  // Only the theme's own submit button adds to the cart. Anything else is a
  // waitlist trigger, and the bar sends the customer up to it.
  var isThemeButton = mainButton === document.querySelector('.product-form__atc [name="add"]');

  // The bar only has room for a short "Add". Every other label (sold out,
  // pre-order, waitlist) is copied as is. The full label stays as the
  // accessible name.
  var fullLabel = readButtonLabel(mainButton);
  var label = fullLabel;
  if (isThemeButton && stickyButton.dataset.shortLabel && /add to (cart|bag)/i.test(fullLabel)) {
    label = stickyButton.dataset.shortLabel;
  }
  if (label && readButtonLabel(stickyButton) !== label) writeButtonLabel(stickyButton, label);
  if (fullLabel) stickyButton.setAttribute('aria-label', fullLabel);

  stickyButton.dataset.stickyMode = isThemeButton ? 'cart' : 'scroll';

  if (isThemeButton && (mainButton.disabled || mainButton.hasAttribute('disabled'))) {
    stickyButton.setAttribute('disabled', 'disabled');
  } else {
    stickyButton.removeAttribute('disabled');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const addToCartForm = document.querySelector('.sticky-add-to-cart_form');
  const stickyAddToCartInfo = document.querySelector('.sticky-add-to-cart');

  if (addToCartForm && stickyAddToCartInfo) {
    const addToCartButton = addToCartForm.querySelector('.button');
    if (!addToCartButton) return;

    syncStickyAddToCart();

    // Klaviyo swaps the button in asynchronously and variants.js relabels it on
    // every variant change, so re-read the main button whenever it changes.
    const productFormButtons = document.querySelector('.product-form__buttons');
    if (productFormButtons && window.MutationObserver) {
      new MutationObserver(syncStickyAddToCart).observe(productFormButtons, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'style', 'class']
      });
    }

    addToCartButton.addEventListener('click', function(event) {
      event.preventDefault();

      if (addToCartButton.hasAttribute('disabled')) return;

      if (addToCartButton.dataset.stickyMode === 'scroll') {
        const mainButton = getMainAddToCartButton();
        // The window scroll handler drops the `fixed` class once the product form
        // is back in view, so the bar gets out of the way on its own.
        if (mainButton) mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const currentVar = stickyAddToCartInfo.getAttribute('data-current-var');
      
      let formData = {
        'items': [{
          'id': currentVar,
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        // A rejected line item used to be reported as a successful add: the cart
        // was refreshed either way and the error body thrown away.
        if (response.ok) {
          refreshCart();
          return;
        }

        return response.json().then(function (content) {
          const errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.textContent = content['description'] || content['message'] || '';
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
          syncStickyAddToCart();
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  }
});

// Product card color slider. This lives here rather than in the snippet so every
// card behaves the same wherever it is rendered: an inline <script> never runs
// when a card is injected with innerHTML (product recommendations), and one copy
// per card would initialise every slider on the page over and over.

var PRODUCT_CARD_SLIDER_OPTIONS = {
  cellSelector: '.active-product-media__thumbnail',
  prevNextButtons: true,
  wrapAround: true,
  pageDots: false,
  setGallerySize: false
};

function initProductCardSliders(root) {
  if (typeof Flickity === 'undefined') return;

  var scope = root || document;

  scope.querySelectorAll('[data-product-card-slider]').forEach(function (gallery) {
    if (Flickity.data(gallery)) return;

    var flkty = new Flickity(gallery, PRODUCT_CARD_SLIDER_OPTIONS);

    // The images are lazy loaded, so the cells get measured before they have a
    // size and the first slides would move by the wrong offset. Re-measure once
    // they land.
    var images = gallery.querySelectorAll('img');
    var pending = images.length;
    if (!pending) return;

    var onImageDone = function () {
      pending -= 1;
      if (pending === 0) flkty.resize();
    };

    images.forEach(function (image) {
      if (image.complete) {
        onImageDone();
        return;
      }
      image.addEventListener('load', onImageDone, { once: true });
      image.addEventListener('error', onImageDone, { once: true });
    });
  });
}

window.initProductCardSliders = initProductCardSliders;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initProductCardSliders();
  });
} else {
  initProductCardSliders();
}

// Product card color swatch — switches the card's thumbnail image.
// Delegated on document so it works no matter how the card reached the DOM
// (normal page render, or markup injected via innerHTML, e.g. product
// recommendations), since a <script> tag inside injected HTML never runs.

document.addEventListener('click', function (e) {
  var swatchItem = e.target.closest('.product-block__swatch-item');
  if (!swatchItem) return;

  var selected = swatchItem.dataset.altvalue;
  var parentNode = swatchItem.closest('.product-card-wrapper');
  if (!parentNode) return;

  parentNode.querySelectorAll('.product-block__swatch-item').forEach(function (itemSwatch) {
    itemSwatch.classList.remove('active');
  });
  swatchItem.classList.add('active');

  parentNode.querySelectorAll('[data-media-alt]').forEach(function (item) {
    item.classList.remove('active-product-media__thumbnail');
  });
  parentNode.querySelectorAll('[data-media-alt="' + selected + '"]').forEach(function (item) {
    item.classList.add('active-product-media__thumbnail');
  });

  var variantImageEl = parentNode.querySelector('[data-variantimage="' + selected + '"]');
  var productIdInput = parentNode.querySelector('.productID');
  if (variantImageEl && productIdInput) {
    productIdInput.value = variantImageEl.dataset.variantid;
  }

  var gallery = parentNode.querySelector('.product-media-slider');
  if (gallery && typeof Flickity !== 'undefined') {
    var flkty = Flickity.data(gallery);
    if (flkty) {
      flkty.destroy();
    }
    new Flickity(gallery, PRODUCT_CARD_SLIDER_OPTIONS);
  }
});

// Maggie Upsell

document.addEventListener('click', function(e) {
  if (e.target.classList.contains('swatch-button')) {
    const swatchButtons = document.querySelectorAll('.swatch-button');
    swatchButtons.forEach(button => button.classList.remove('active'));
    e.target.classList.add('active');
    const variantId = e.target.getAttribute('data-variant-id');

    const addButton = document.querySelector('.add-maggie-button');
    addButton.setAttribute('data-variant-id', variantId);
    addButton.removeAttribute('disabled');

    const variantTitle = e.target.getAttribute('data-variant-title');
    const variantTitleElement = document.getElementById('maggie-variant-title');
    variantTitleElement.textContent = variantTitle;
  }

  if (e.target.classList.contains('add-maggie-button') || e.target.closest('.add-maggie-button')) {
    if (!e.target.classList.contains('add-maggie-button')) {
      e.target = e.target.closest('.add-maggie-button');
    }
    e.preventDefault();
    e.target.setAttribute('disabled', 'disabled');

    var varId = e.target.getAttribute('data-variant-id') * 1;

    let formData = {
      'items': [{
        'id': varId,
        'quantity': 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(function(response) {
      if (response.ok) {
        e.target.removeAttribute('disabled');
        refreshCart();
      } else {
        response.json().then(function(content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          e.target.removeAttribute('disabled');
          e.target.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function() {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  }
});
